module.exports = __webpack_public_path__ + "static/espa-6e745f0d7862168745d4b25bf32192df.jpg";